export const setLoggingContext = (key, value) => {
  window.DD_LOGS && window.DD_LOGS.addLoggerGlobalContext(key, value);
};